var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03125 0.875C5.39062 0.875 5.75 1.23438 5.75 1.59375V3.75H14.375V1.59375C14.375 1.23438 14.6895 0.875 15.0938 0.875C15.4531 0.875 15.8125 1.23438 15.8125 1.59375V3.75H17.25C18.8223 3.75 20.125 5.05273 20.125 6.625V21C20.125 22.6172 18.8223 23.875 17.25 23.875H2.875C1.25781 23.875 0 22.6172 0 21V6.625C0 5.05273 1.25781 3.75 2.875 3.75H4.3125V1.59375C4.3125 1.23438 4.62695 0.875 5.03125 0.875ZM18.6875 9.5H1.4375V21C1.4375 21.8086 2.06641 22.4375 2.875 22.4375H17.25C18.0137 22.4375 18.6875 21.8086 18.6875 21V9.5ZM17.25 5.1875H2.875C2.06641 5.1875 1.4375 5.86133 1.4375 6.625V8.0625H18.6875V6.625C18.6875 5.86133 18.0137 5.1875 17.25 5.1875Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4913bb24541d3e0668f058859ef35dc0.svg";
export { ForwardRef as ReactComponent };